import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const legacyIssueCreateInitialRenderInteraction: Metric = metrics.interaction({
	key: 'legacy-issue-create.initial-render',
});

export const legacyIssueCreateTransitionInteraction: Metric = metrics.interaction({
	key: 'legacy-issue-create.transition',
});

export const legacyIssueCreateCombinedInteraction: Metric = metrics.interaction({
	key: 'legacy-issue-create.combined',
});
